import { API_URL as API } from "../config";

const fetchMyProfile = async (accessToken) => {
    const request = await fetch(`${API}/profile`, {
        method: "GET",
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    return await request.json();
};

const updateMyProfile = async (updates, accessToken) => {
    const request = await fetch(`${API}/profile`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" },
        body: JSON.stringify(updates),
    });
    return { ok: request.ok, status: request.status, body: await request.json() };
};

const fetchPublicProfile = async (username) => {
    const request = await fetch(`${API}/profile/${username}`, { method: "GET" });
    return await request.json();
};

const fetchFollowStatus = async (username, accessToken) => {
    const request = await fetch(`${API}/profile/${username}/follow`, {
        method: "GET",
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    return await request.json();
};

const followUser = async (username, accessToken) => {
    const request = await fetch(`${API}/profile/${username}/follow`, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    return await request.json();
};

const unfollowUser = async (username, accessToken) => {
    const request = await fetch(`${API}/profile/${username}/follow`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    return await request.json();
};

export { fetchMyProfile, updateMyProfile, fetchPublicProfile, fetchFollowStatus, followUser, unfollowUser };
